module.exports = __webpack_public_path__ + "img/danger-flag.3839e24.svg";